import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { Icon } from '@iconify/react/dist/iconify.js';
import { formatIstDate } from '../../../../utils/helpers/istDate';

const FREQUENCY_OPTIONS = [
    { value: 'daily', label: 'Daily' },
    { value: 'weekly', label: 'Weekly' },
    { value: 'monthly', label: 'Monthly' },
    { value: 'yearly', label: 'Yearly' },
];

const fmt = (n) => (n ?? 0).toLocaleString('en-IN');

const EarningStaticOne = ({ loginStatistics, frequency = 'monthly', onFrequencyChange = () => { } }) => {
    const loggedIn = loginStatistics?.loggedIn ?? 0;
    const loggedOut = loginStatistics?.loggedOut ?? 0;
    const activeUsers = loginStatistics?.activeUsers ?? 0;

    const options = {
        chart: { type: 'bar', toolbar: { show: false } },
        plotOptions: {
            bar: { borderRadius: 4, columnWidth: '50%', distributed: true },
        },
        dataLabels: { enabled: false },
        colors: ['#487fff', '#f4941e', '#45b369'],
        xaxis: { categories: ['Logged In', 'Logged Out', 'Active Users'] },
        yaxis: { labels: { formatter: (v) => fmt(v) } },
        legend: { show: false },
        grid: { borderColor: '#e0e0e0' },
        tooltip: { y: { formatter: (v) => fmt(v) } },
    };

    const series = [{ name: 'Users', data: [loggedIn, loggedOut, activeUsers] }];

    return (
        <div className="col-xxl-8">
            <div className="card h-100 radius-8 border-0">
                <div className="card-body p-24">
                    <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between">
                        <div>
                            <h6 className="mb-2 fw-bold text-lg">Login Statistics</h6>
                            <span className="text-sm fw-medium text-secondary-light">
                                {loginStatistics?.window?.from
                                    ? `${formatIstDate(loginStatistics.window.from)} – ${formatIstDate(loginStatistics.window.to)}`
                                    : 'Current Window'}
                            </span>
                        </div>
                        <div>
                            <select
                                className="form-select form-select-sm w-auto bg-base border text-secondary-light"
                                value={frequency}
                                onChange={(e) => onFrequencyChange(e.target.value)}
                            >
                                {FREQUENCY_OPTIONS.map((o) => (
                                    <option key={o.value} value={o.value}>{o.label}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                    <div className="mt-20 d-flex justify-content-center flex-wrap gap-3">
                        <div className="d-inline-flex align-items-center gap-2 p-2 radius-8 border pe-36 br-hover-primary group-item">
                            <span className="bg-neutral-100 w-44-px h-44-px text-xxl radius-8 d-flex justify-content-center align-items-center text-secondary-light group-hover:bg-primary-600 group-hover:text-white">
                                <Icon icon="mingcute:user-follow-fill" className="icon" />
                            </span>
                            <div>
                                <span className="text-secondary-light text-sm fw-medium">Logged In</span>
                                <h6 className="text-md fw-semibold mb-0">{fmt(loggedIn)}</h6>
                            </div>
                        </div>
                        <div className="d-inline-flex align-items-center gap-2 p-2 radius-8 border pe-36 br-hover-primary group-item">
                            <span className="bg-neutral-100 w-44-px h-44-px text-xxl radius-8 d-flex justify-content-center align-items-center text-secondary-light group-hover:bg-primary-600 group-hover:text-white">
                                <Icon icon="mdi:logout" className="icon" />
                            </span>
                            <div>
                                <span className="text-secondary-light text-sm fw-medium">Logged Out</span>
                                <h6 className="text-md fw-semibold mb-0">{fmt(loggedOut)}</h6>
                            </div>
                        </div>
                        <div className="d-inline-flex align-items-center gap-2 p-2 radius-8 border pe-36 br-hover-primary group-item">
                            <span className="bg-neutral-100 w-44-px h-44-px text-xxl radius-8 d-flex justify-content-center align-items-center text-secondary-light group-hover:bg-primary-600 group-hover:text-white">
                                <Icon icon="mdi:radiobox-marked" className="icon" />
                            </span>
                            <div>
                                <span className="text-secondary-light text-sm fw-medium">Active Users</span>
                                <h6 className="text-md fw-semibold mb-0">{fmt(activeUsers)}</h6>
                            </div>
                        </div>
                    </div>
                    <div id="barChart">
                        <ReactApexChart options={options} series={series} type="bar" height={310} />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default EarningStaticOne;
